import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { logAdminAction } from '../../utils/auditLogger';

const { FiClock, FiShield } = FiIcons;

const SLOW_MODE_OPTIONS = [
  { label: 'Desactivado (0s)', value: 0 },
  { label: '5 Segundos', value: 5 },
  { label: '10 Segundos', value: 10 },
  { label: '30 Segundos', value: 30 },
  { label: '60 Segundos', value: 60 }
];

export default function SlowModeControl({ settings, onUpdateSettings, adminProfile }) {
  const currentSeconds = settings?.slow_mode_seconds || 0;
  const [updating, setUpdating] = useState(false);

  const handleSelectOption = async (seconds) => {
    if (seconds === currentSeconds || updating) return;
    setUpdating(true);
    try {
      await onUpdateSettings({ slow_mode_seconds: seconds });
      await logAdminAction(
        adminProfile?.username,
        'CAMBIO_MODO_LENTO',
        'Chat General',
        `Intervalo fijado a ${seconds} segundos`
      );
    } catch (err) {
      console.error(err);
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div className="rounded-2xl border border-white/10 bg-[#111] p-5 space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-purple-500/10 text-purple-400">
            <SafeIcon icon={FiClock} size={18} />
          </span>
          <div>
            <h3 className="font-semibold text-white text-sm sm:text-base">Modo Lento de Chat (Slow Mode)</h3>
            <p className="text-xs text-gray-500">Restringe el tiempo de espera obligatorio entre mensajes por usuario</p>
          </div>
        </div>
        <span className={`px-2 py-0.5 text-[10px] font-bold rounded-full ${currentSeconds > 0 ? 'bg-purple-500/20 text-purple-300' : 'bg-gray-800 text-gray-400'}`}>
          {currentSeconds > 0 ? `${currentSeconds}s Activo` : 'Inactivo'}
        </span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 pt-1">
        {SLOW_MODE_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            disabled={updating}
            onClick={() => handleSelectOption(opt.value)}
            className={`py-2 px-3 rounded-xl text-xs font-semibold border transition-all ${
              currentSeconds === opt.value
                ? 'bg-purple-600 text-white border-purple-500 shadow-lg shadow-purple-600/20'
                : 'bg-white/5 border-white/10 text-gray-300 hover:bg-white/10'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}